// A date as Sanctuary parses it: ISO 8601 without the fractional seconds that
// toISOString always includes.
export function isoTimestamp(date: Date) {
  return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
}
